// extracted by mini-css-extract-plugin
module.exports = {"title":"LoginSignupHeader_title__qgXpJ","subtitle":"LoginSignupHeader_subtitle__Jsqw9","link":"LoginSignupHeader_link__BZZCQ"};